import { CurrencyRateDto, mapCurrencyRateDto, type CurrencyRate } from './currency-rate.model';

/** SCO sample used by the test source. Dates and rates match the kiosk wireframes. */
export const TEST_CURRENCY_RATE_DTOS: readonly CurrencyRateDto[] = [
  {
    code: 'AUD',
    description: 'Australian Dollar',
    roundingFactor: 0.01,
    decimals: 2,
    validFrom: '2026-07-23T00:00:00',
    localValue: 1.0,
    change: 2.220002,
  },
  {
    code: 'BHD',
    description: 'Bahrain Dinar',
    roundingFactor: 1.0,
    decimals: 2,
    validFrom: '2026-07-23T00:00:00',
    localValue: 1.0,
    change: 9.74374,
  },
  {
    code: 'CAD',
    description: 'Canadian Dollar',
    roundingFactor: 0.01,
    decimals: 2,
    validFrom: '2026-07-23T00:00:00',
    localValue: 1.0,
    change: 2.614516,
  },
  {
    code: 'CHF',
    description: 'Swiss Franc',
    roundingFactor: 0.01,
    decimals: 2,
    validFrom: '2026-07-23T00:00:00',
    localValue: 1.0,
    change: 4.029983,
  },
  {
    code: 'EUR',
    description: 'Euro',
    roundingFactor: 1.0,
    decimals: 2,
    validFrom: '2026-07-23T00:00:00',
    localValue: 1.0,
    change: 4.191642,
  },
  {
    code: 'GBP',
    description: 'British Pound',
    roundingFactor: 1.0,
    decimals: 2,
    validFrom: '2026-07-23T00:00:00',
    localValue: 1.0,
    change: 4.937784,
  },
  {
    code: 'KWD',
    description: 'Kuwait Dinar',
    roundingFactor: 0.01,
    decimals: 2,
    validFrom: '2026-07-23T00:00:00',
    localValue: 1.0,
    change: 11.941724,
  },
  {
    code: 'OMR',
    description: 'Oman Riyal',
    roundingFactor: 1.0,
    decimals: 2,
    validFrom: '2026-07-23T00:00:00',
    localValue: 1.0,
    change: 9.541985,
  },
  {
    code: 'QAR',
    description: 'Qatari Riyal',
    roundingFactor: 0.01,
    decimals: 2,
    validFrom: '2026-07-23T00:00:00',
    localValue: 1.0,
    change: 0.839997,
  },
  {
    code: 'SAR',
    description: 'Saudi Riyal',
    roundingFactor: 1.0,
    decimals: 2,
    validFrom: '2026-07-23T00:00:00',
    localValue: 1.0,
    change: 0.978043,
  },
  {
    code: 'SGD',
    description: 'Singapore Dollar',
    roundingFactor: 0.01,
    decimals: 2,
    validFrom: '2026-07-23T00:00:00',
    localValue: 1.0,
    change: 2.269993,
  },
  {
    code: 'USD',
    description: 'US Dollar',
    roundingFactor: 1.0,
    decimals: 2,
    validFrom: '2026-07-23T00:00:00',
    localValue: 1.0,
    change: 3.668513,
  },
];

export const TEST_CURRENCY_RATES: CurrencyRate[] = TEST_CURRENCY_RATE_DTOS.map(dto =>
  mapCurrencyRateDto(dto)!,
);
